import * as React from 'react';
import { useMemo } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { ListItemText } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useMeContext } from 'modules/me';

type useStylesProp = {
  isInstalled: boolean;
  disableConnectorTenant: boolean;
};

const useStyles = makeStyles((theme) => ({
  menuIcon: {
    '&.MuiListItemIcon-root': {
      color: theme.palette.common.black,
      minWidth: theme.spacing(4)
    }
  },

  paper: {
    opacity: 1
  },

  menu: {
    top: theme.spacing(0.5),
    left: ({ isInstalled }: useStylesProp) =>
      isInstalled ? theme.spacing(2.4) : theme.spacing(0.5)
  },
  menuListstyle: {
    padding: theme.spacing(0),
    backgroundColor: theme.palette.information.pageBackground
  },
  menuItem: {
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.5),
    minWidth: theme.spacing(15.5)
  },
  MenuDivider: {
    margin: theme.spacing(0)
  },
  forwardIcon: {
    paddingLeft: theme.spacing(1.7),
    color: theme.palette.common.black,
    fontSize: theme.spacing(3.6)
  },
  companyDiv: {
    pointerEvents: ({
      disableConnectorTenant: disableCollectorTenant
    }: useStylesProp) => (disableCollectorTenant ? 'none' : 'auto')
  }
}));

type MenuPopperProp = {
  menuItem: {
    name: string;
    onClick: () => void;
    testId: string;
  }[];
  anchorPopper: React.RefObject<HTMLLIElement>;
  anchorMenu: HTMLElement | null;
  isInstalled: boolean;
  handleButtonClose: () => void;
};

export const MenuPopper: React.FC<MenuPopperProp> = ({
  menuItem,
  anchorPopper,
  anchorMenu,
  isInstalled,
  handleButtonClose
}: MenuPopperProp) => {
  const me = useMeContext();
  const isAdmin = useMemo(() => {
    return me?.permissions.hasCompanyConnectorInstallAccess ? true : false;
  }, [me]);

  const classes = useStyles({
    isInstalled,
    disableConnectorTenant: isInstalled && !isAdmin
  });
  return (
    <div data-testid="render-menu">
      <Menu
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        MenuListProps={{ className: classes.menuListstyle }}
        onClose={handleButtonClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        elevation={1}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        className={classes.menu}
        data-testid="menu-item-list"
      >
        <div data-testid="check-all-menuItem">
          {menuItem.map((item) => (
            <MenuItem
              data-testid={item.testId}
              className={classes.menuItem}
              ref={anchorPopper}
              onClick={item.onClick}
              key={item.name}
            >
              <ListItemText>{item.name}</ListItemText>
            </MenuItem>
          ))}
        </div>
      </Menu>
    </div>
  );
};
